import React from 'react';
import { useIntl } from 'react-intl';

const UnauthorizedErrorPage = () => {
  const intl = useIntl();
  return (
    <>
      <div className="shadow-2 dls-white-bg margin-auto-lr margin-2-tb pad-3-t pad-2-b" data-testid="error-root">
        <div data-module-name="identity-components-message">
          <div className="dls-white-bg pad flex flex-column flex-align-center">
            <span
              className="icon dls-icon-warning icon-lg margin-2-tb dls-color-warning"
              data-testid="card_icon"
            />
            <h1 className="heading-4 margin-1-b" data-testid="error_header">
              {intl.formatMessage({ id: 'error.header' })}
            </h1>
            <p className="body-3" data-testid="error_desc">
              {intl.formatMessage({ id: 'error.message' })}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnauthorizedErrorPage;
